import { QuestionBase } from './question-base';

export class RadioBooleanQuestion extends QuestionBase<boolean> {
  controlType = 'radio-boolean';
}
